export const doesPasswordsMatch = ({ password, passwordConfirmation }) =>
  !passwordConfirmation || password === passwordConfirmation;

export const passwordPresent = passwordStrength =>
  passwordStrength && !!passwordStrength.password;



// WEBPACK FOOTER //
// ./webpack/assets/javascripts/react_app/components/PasswordStrength/PasswordStrengthSelectors.js